import React from "react";
import Svg from "../../../components/Svg/Svg";
import { SvgProps } from "../../../components/Svg/types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <path d="M 11.1875 1.359375 L 4.1875 4.472656 C 3.464844 4.792969 3 5.507813 3 6.300781 L 3 11 C 3 18.828125 9.4375 22.484375 12 23 C 14.5625 22.484375 21 18.828125 21 11 L 21 6.300781 C 21 5.511719 20.535156 4.792969 19.8125 4.472656 L 12.8125 1.359375 C 12.296875 1.132813 11.703125 1.132813 11.1875 1.359375 Z M 10.292969 15.707031 L 7.523438 12.9375 C 7.132813 12.546875 7.132813 11.914063 7.523438 11.523438 C 7.914063 11.132813 8.546875 11.132813 8.9375 11.523438 L 11 13.585938 L 16.085938 8.5 C 16.476563 8.109375 17.109375 8.109375 17.5 8.5 C 17.890625 8.890625 17.890625 9.523438 17.5 9.914063 L 11.707031 15.707031 C 11.316406 16.097656 10.683594 16.097656 10.292969 15.707031 Z "/>
    </Svg>
  );
};

export default Icon;
